module.exports = __webpack_public_path__ + "621913f3c27d99ba45817a39036b7cf4.ttf";